module.exports = __webpack_public_path__ + "static/img/sec3-cont-img01@t.8d60b63.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem-history/sec3-cont-img01@t.jpg
// module id = YGZN
// module chunks = 0